export default [
  [
    {
      id: 'plateNumber',
      label: 'ทะเบียนรถ',
      span: 8,
      type: 0,
      props: { padding: '8px 0', margin: '0 8px 0 0', title: { text: 'ทะเบียนหัว *' } },
    }, {
      id: 'chassisNumber',
      label: 'เลขคัตซี',
      span: 8,
      type: 0,
      props: { padding: '8px 0', margin: '0 8px 0 0', title: { text: 'เลขคัตซี' } },
    }, {
      id: 'brandId',
      label: 'ยี่ห้อรถ',
      span: 8,
      type: 12,
      props: { padding: '8px 0', margin: '0 8px 0 0', title: { text: 'ยี่ห้อรถ' } },
    }, {
      id: 'truckTypeId',
      label: 'ชนิดรถ *',
      span: 8,
      type: 6,
      props: { margin: '0 40px 0 0', width: '240px', title: { text: 'ชนิดรถ' } },
      children: [],
    }, {
      id: 'trailerId', // plateNumber2 => trailerPlate
      label: 'ทะเบียนหางพ่วง',
      span: 8,
      type: 10,
    }, {
      id: 'truckTypeId',
      label: 'ชนิดหางพ่วง',
      span: 8,
      type: 11,
      props: { margin: '0 40px 0 0', width: '240px', title: { text: 'ชนิดหางพ่วง' } },
      children: [],
    },
  ], [
    {
      id: 'driverId', // driverId
      label: 'คนขับประจำ *',
      span: 12,
      type: 9,
      props: { padding: '8px 0', margin: '0 8px 0 0', title: { text: 'คนขับประจำ' } },
      children: [],
    }, {
      id: 'truckOwnerId', // truckOwnerId
      label: 'เจ้าของรถ *',
      span: 6,
      type: 6,
      props: { padding: '8px 0', margin: '0 8px 0 0', title: { text: 'เจ้าของรถ' } },
      children: [],
    }, {
      id: 'truckOwnerObj', // truckTypeId
      label: 'ประเภทรถ',
      span: 6,
      type: 7,
    }, {
      id: 'truckFiles', // truckTypeId
      label: 'รูปรถ',
      span: 12,
      type: 13,
    },
  ], [
    {
      id: 'fleet',
      label: 'fleet',
      span: 8,
      type: 8,
      disabled: true,
      props: { margin: '0 40px 0 0', width: '240px', title: { text: 'สังกัด' } },
    }, {
      id: 'fuelType',
      label: 'ประเภทเชื้อเพลิง *',
      span: 8,
      type: 6,
      defaultValue: 'ดีเซล',
      props: { margin: '0 40px 0 0', width: '100px', title: { text: 'ประเภทเชื้อเพลิง' } },
    }, {
      id: 'truckWeight',
      label: 'น้ำหนักรถ',
      span: 8,
      type: 0,
      valueType: 'int',
      props: { title: { text: 'น้ำหนักรถ' } },
    },
  ],
  [
    {
      id: 'remark',
      label: 'หมายเหตุ',
      span: 12,
      type: 5,
      props: { rows: 4 },
    },
  ],
]
